import React, { FunctionComponent } from 'react';
import WearyCat from '../../../../img/1f640.png';

interface ErrorProps {
  styles?: string;
}

const Error: FunctionComponent<ErrorProps> = ({ styles }: ErrorProps) => (
  <div
    className={`${styles ? `${styles} ` : ''}d-flex align-items-center justify-content-center flex-column p-6`}
    data-test-id="WearyCat"
  >
    <img alt={WearyCat} className="icon-large" src={WearyCat} />
    <h4 className="mt-4 mb-0">The cord&apos;s come out</h4>
    <p className="text-center">
      The thing that connects the other thing is not working. Try reloading the page or come back later.
    </p>
  </div>
);

export default Error;
